import StSystemNavigationDrawer from '@/language/pt/StSystemNavigationDrawer';
import StCompanySelection from '@/language/pt/StCompanySelection';
import LoginView from '@/language/pt/LoginView';
import ErrorStatus from '@/language/pt/ErrorStatus';
import DataManagement from '@/language/pt/DataManagement';
import views from '@/language/pt/views';
import components from '@/language/pt/components';
import mixins from '@/language/pt/mixins';
import BrandHealth from '@/language/pt/BrandHealth';
import stocks from '@/language/pt/stocks';
import DistributionMediaPieChart from '@/language/pt/DistributionMediaPieChart';
import library from '@/language/pt/library';
import utils from '@/language/pt/utils';

export default {
  systemName: 'Dash',
  StSystemNavigationDrawer,
  StCompanySelection,
  LoginView,
  ErrorStatus,
  DataManagement,
  views,
  components,
  mixins,
  BrandHealth,
  stocks,
  DistributionMediaPieChart,
  library,
  utils,
};
